//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*当前页面是死路径的注册方法
    import MySchedule from "@/views/overseasChinese/MySchedule.vue";
    import classRoomTimetable from "@/views/overseasChinese/classRoomTimetable.vue";
    ;*/
export default {
  name: "queryTypeModal",
  props: ["data"],
  data: function data() {
    return {};
  },
  computed: {
    component: function component() {
      // 动态路径注册，在页面服务菜单里面去配置全路径就可以了
      var queryPcUrl = this.data.data.queryPcUrl || "views/overseasChinese/classRoomTimetable.vue";
      return function () {
        return import("@/".concat(queryPcUrl));
      };
    }
  },
  components: {
    /*  MySchedule, // 我的课表
            classRoomTimetable, // 教室课表
           */
  },
  watch: {
    "data.show": {
      handler: function handler(val, oldVal) {
        if (val) {
          console.log(this.data.data);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    onSubmit: function onSubmit() {
      this.$emit("close", this.treeItem);
      this.data.show = false;
    },
    onClose: function onClose() {}
  }
};